/**
 * @generated SignedSource<<ccbed41382c20cb81803d2b548fd3705>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespSearchResultContainer_viewer$data = {
  readonly isSbTradeFreeShippingTestDisabled?: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_viewer" | "SbSharedItemTrackingProvider_viewer">;
  readonly " $fragmentType": "SbRespSearchResultContainer_viewer";
};
export type SbRespSearchResultContainer_viewer$key = {
  readonly " $data"?: SbRespSearchResultContainer_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespSearchResultContainer_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespSearchResultContainer_viewer",
  "selections": [
    {
      "condition": "isTrade",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "isSbTradeFreeShippingTestDisabled",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "disableSbTradeFreeShippingTest"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": "isEnabled(key:\"disableSbTradeFreeShippingTest\")"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedItemTrackingProvider_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "baca45a9b9ca45a82d1d6521d45e0059";

export default node;
